import { Shield, Heart, Phone, Mail } from 'lucide-react';
import { Separator } from './ui/separator';

const Footer = () => {
  const quickLinks = [
    { label: 'Highlights', href: '#highlights' },
    { label: 'Floor Plans', href: '#floor-plans' },
    { label: 'Location', href: '#location' },
    { label: 'Testimonials', href: '#reviews' }
  ];

  function scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <div className="flex items-center space-x-2 mb-6">

                <span className="text-2xl font-bold">Blucon Sunrise</span>
              </div>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                Crafting lifestyles, building trust. Contact us today to find your dream home in a prime Chennai location.
              </p>


            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Quick Links</h3>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <button
                      onClick={() => scrollToSection(link.href.substring(1))}
                      className="text-gray-300 hover:text-amber-400 transition-colors text-left"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Registered Office</h3>
              <div className="space-y-2">
                <div className="text-gray-300 font-semibold">
                  MEENAKSHI SUPERSTRUCTURES
                </div>
                <div className="text-gray-300 leading-relaxed">
                  Flat No 112, Block -1, Blucon Sunshine Apts,<br />
                  Gergumbakkam Main Rd, Gergumbakkam,<br />
                  Chennai - 600116
                </div>
              </div>
            </div>

            {/* Contact & Social */}
            <div>
              <h3 className="text-xl font-semibold mb-6">Contact Us</h3>
              <div className="space-y-3">
                <div className="flex items-center text-gray-300">
                  <Phone className="w-4 h-4 mr-3 text-amber-400" />
                  +91 8754488883
                </div>
                <div className="flex items-center text-gray-300">
                  <Mail className="w-4 h-4 mr-3 text-amber-400" />
                  info@blucon.co.in
                </div>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-gray-800" />

        {/* Certifications & Awards */}
        <div className="py-8">
          <div className="grid md:grid-cols-2 gap-6 text-center">
            <div className="flex flex-col items-center">
              <Shield className="w-8 h-8 text-amber-400 mb-2" />
              <span className="text-sm text-gray-300">RERA Approved</span>
            </div>
            <div className="flex flex-col items-center">
              <Heart className="w-8 h-8 text-amber-400 mb-2" />
              <span className="text-sm text-gray-300">200+ Happy Families</span>
            </div>
          </div>
        </div>

        <Separator className="bg-gray-800" />



        {/* Copyright */}
        <div className="py-6 text-center">
          <p className="text-gray-400 text-sm mb-2">
            © 2025 Blucon Sunrise Residences. All rights reserved.
          </p>
          <p className="text-xs text-gray-500">
            RERA Registration No: TN/29/BUILDING/0252/2025 | 
            Valid till: 31/12/2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;